import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * V2.15.3 — Reset scroll to top on every client-side route change.
 *
 * React Router does NOT auto-scroll on navigation, so clicking a card at the
 * bottom of a long list (catalogue, subsidies) would land users on the next
 * page scrolled near the footer. Mount this component once inside the Router.
 *
 * Uses `behavior: "instant"` so the reset is imperceptible (smooth would feel
 * laggy on route change).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
